/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Import_TitleInputs */

const en_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Presets`)
};

const fr_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer des presets`)
};

const de_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import-Voreinstellungen`)
};

const it_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa preset`)
};

const ru_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импорт пресетов`)
};

const es_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar ajustes preestablecidos`)
};

const zh_cn2_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入预设`)
};

const ja_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットをインポート`)
};

const hi_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट आयात करें`)
};

const pt_pt2_preset_manager_import_title = /** @type {(inputs: Preset_Manager_Import_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importar predefinições`)
};

/**
* | output |
* | --- |
* | "Import Presets" |
*
* @param {Preset_Manager_Import_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_import_title = /** @type {((inputs?: Preset_Manager_Import_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Import_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_import_title(inputs)
	if (locale === "de") return de_preset_manager_import_title(inputs)
	if (locale === "it") return it_preset_manager_import_title(inputs)
	if (locale === "ru") return ru_preset_manager_import_title(inputs)
	if (locale === "es") return es_preset_manager_import_title(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_import_title(inputs)
	if (locale === "ja") return ja_preset_manager_import_title(inputs)
	if (locale === "hi") return hi_preset_manager_import_title(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_import_title(inputs)
	return en_preset_manager_import_title(inputs)
});